import { render } from "./globalPopup.vue?vue&type=template&id=3ba287a8"
import script from "./globalPopup.vue?vue&type=script&lang=js"
export * from "./globalPopup.vue?vue&type=script&lang=js"

import "./less/globalPopup.less?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__